<template>
  <InterfaceCard
      icon="mdi-account"
      title="Мой профиль"
  >
    <template slot="tabs">
      <v-tabs
          v-model="currentTab"
          :show-arrows="$vuetify.breakpoint.mobile"
      >
        <v-tabs-slider color="pink"></v-tabs-slider>

        <v-tab
            icons-and-text
            v-for="tab in tabs"
            :key="tab.id"
        >
          <v-icon left>{{tab.icon}}</v-icon>
          {{ tab.title }}
        </v-tab>
      </v-tabs>
    </template>

    <UserProfileCommon v-if="currentTab === tabs[0].id"/>
    <UserProfileBalances v-if="currentTab === tabs[1].id"/>
    <UserProfilePickupPoint
        v-if="currentTab === tabs[2].id"
        :source-id="sourceId"
    />
  </InterfaceCard>
</template>

<script>
import InterfaceCard from '@/components/InterfaceCard'
import UserProfileBalances from '@/components/UserProfileBalances'
import UserProfileCommon from '@/components/UserProfileCommon'
import UserProfilePickupPoint from '@/components/UserProfilePickupPoint'

const tabs = [{
  id: 0,
  title: 'Общее'
},{
  id: 1,
  title: 'Балансы'
},{
  id: 2,
  title: 'Точка выдачи по умолчанию'
}]

export default {
  name: 'UserProfileSourceContext',
  components: {UserProfilePickupPoint, UserProfileCommon, UserProfileBalances, InterfaceCard},
  created () {
    this.sourceId = '' + this.$route.params.sourceId
  },
  data () {
    return {
      currentTab: tabs[0].id,
      sourceId: null,
      tabs: tabs
    }
  }
}
</script>

<style scoped>

</style>